<template>
  <div class="wrapper">    
    <div class="main-panel full-page">      
      <Navbar/>
      <div class="content">
        <router-view/>
      </div>      
    </div>
  </div>
</template>

<script>

import Navbar from './Navbar';

export default {
  components: {
    Navbar,    
  }
}
</script>

<style scoped>
  .full-page {
    width: 100%
  }
</style>